import { useState } from 'react';
import { fmtTime } from '../lib/format';

interface Props {
  email: string;
  link: string;
  expiresAt: string;
  onClose: () => void;
}

export default function MagicLinkModal({ email, link, expiresAt, onClose }: Props) {
  const [copied, setCopied] = useState(false);

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // 退而求其次:選取輸入框內容
      const el = document.getElementById('magic-link-input') as HTMLInputElement | null;
      el?.select();
    }
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <header>
          <h3>登入連結已產生</h3>
          <button className="linkish" onClick={onClose}>關閉</button>
        </header>

        <p>
          收件人:<b>{email}</b>
          <br />
          需於 <span className="warn">{fmtTime(expiresAt)}</span> 前點擊
          <span className="muted"> (未點擊有效期 24 小時;點擊後 session 自動延長為 30 天)</span>
        </p>

        <div className="copy-row">
          <input
            id="magic-link-input"
            type="text"
            readOnly
            value={link}
            onFocus={e => e.currentTarget.select()}
          />
          <button onClick={copyLink}>{copied ? '已複製' : '複製連結'}</button>
        </div>

        <p className="muted small">
          ⚠ 任何人持有此連結都可登入該帳號,請僅在安全管道分享(例如公司即時通)。
          連結一旦被點擊即建立 30 天 session;未使用前可隨時被覆寫(再次按下「產生」會建立新連結)。
        </p>
      </div>
    </div>
  );
}
